import { render, staticRenderFns } from "./index.vue?vue&type=template&id=cafde5a6&scoped=true"
import script from "./index.vue?vue&type=script&setup=true&name=Account&lang=js"
export * from "./index.vue?vue&type=script&setup=true&name=Account&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=cafde5a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cafde5a6",
  null
  
)

export default component.exports